export default {
  namespaced: true,
  state: {
    specification: false,
    compatibleProduct: false,
    resourcesAndTools: false,
    overviewAndFeatures: false,
    screenWidth: 0
  },
  getters: {
    getSpecification: state => state.specification,
    getCompatibleProduct: state => state.compatibleProduct,
    getResourcesAndTools: state => state.resourcesAndTools,
    getOverviewAndFeatures: state => state.overviewAndFeatures,
    getScreenWidth: state => state.screenWidth
  },
  mutations: {
    TOGGLE_SPECIFICATION(state) {
      state.specification = !state.specification;
    },
    TOGGLE_COMPATIBLE(state) {
      state.compatibleProduct = !state.compatibleProduct;
    },
    SET_COMPATIBLE_OPEN(state) {
      state.compatibleProduct = true;
    },
    TOGGLE_RESOURCES(state) {
      state.resourcesAndTools = !state.resourcesAndTools;
    },
    TOGGLE_OVERVIEW(state) {
      state.overviewAndFeatures = !state.overviewAndFeatures;
    },
    UPDATE_SCREEN_WIDTH(state, value) {
      state.screenWidth = value;
    }
  },
  actions: {
    toggleSpecification({ commit }) {
      commit("TOGGLE_SPECIFICATION");
    },
    toggleCompatible({ commit, state }) {
      commit("TOGGLE_COMPATIBLE");
      return state.compatibleProduct;
    },
    setCompatibleOpen({ commit }) {
      commit("SET_COMPATIBLE_OPEN");
    },
    toggleResources({ commit }) {
      commit("TOGGLE_RESOURCES");
    },
    toggleOverview({ commit }) {
      commit("TOGGLE_OVERVIEW");
    },
    updateScreenWidth({ commit }, value) {
      commit("UPDATE_SCREEN_WIDTH", value);
    }
  }
};
